module.exports = __webpack_public_path__ + "img/home4.5aaa3e2c.png";